<template>
  <router-link
    :to="{name: 'regatta_info', params: {regattaId: regattaId}}"
  ><slot>{{text}}</slot></router-link>
</template>

<script>

export default {
  name: 'RegattaLink',

  props: {
    regattaId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'регата',
    },
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.regattaId.toString();

      if(label.length === 0) {
        return idStr;
      }

      return label + ' ' + idStr;
    },
  },
}
</script>
